import { getInstitutions } from '../services/institutions';
import { format } from 'date-fns';

export const getYearsArray = () => {
	const currentYear = new Date().getFullYear();
	const range = (start: any, stop: any, step: any) =>
		Array.from(
			{ length: (stop - start) / step + 1 },
			(_, i) => start + i * step
		);
	const years = range(currentYear, currentYear - 120, -1);
	return years.map((y) => ({ value: y.toString(), label: y }));
};

export const getInstitutionsOptions = async () => {
	const { data } = await getInstitutions(0, 1000);
	let options = data.map((e: any) => ({ value: e.id, label: e.name }));
	return options;
};

export const formatFakePathFile = (path: string) => {
	return path.replace(/^.*\\/, '');
};

export const formatDateToTimeZone = (date: Date | string) => {
	let dt = new Date(date);
	let dateOnly = dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000;
	return format(new Date(dateOnly), 'yyyy-MM-dd').toString();
};

export const formatDateToTimeZoneDate = (date: Date | string) => {
	let dt = new Date(date);
	let dateOnly = dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000;
	return format(new Date(dateOnly), 'yyyy-MM-dd');
};
